import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { cacheKeys } from '../../cacheKeys';
import { QueryConfig } from '@/react-query';
import { GetStaffMemberRequest, GetStaffMemberResponse } from './getStaffMember.types';
import { getStaffMember } from './getStaffMember.api';
import { useAppContext } from '@/context/context';
import { useEffect } from 'react';

type GetStaffMemberOptions = QueryConfig<typeof getStaffMember>;

const EMPTY_STAFF_MEMBER: GetStaffMemberResponse = {} as GetStaffMemberResponse;

export function useStaffMember(request?: GetStaffMemberRequest, options: GetStaffMemberOptions = {}) {
  const { setSnackbar } = useAppContext() || {};

  const { data, error, ...rest } = useQuery<GetStaffMemberResponse, AxiosError<unknown>>({
    queryKey: cacheKeys.getStaffMember(request),
    queryFn: async () => await getStaffMember(request),
    staleTime: 5000,
    ...options
  });

  useEffect(() => {
    if (error && setSnackbar) {
      setSnackbar({ severity: 'error', message: 'אירעה שגיאה בטעינת חבר הצוות', open: true });
    }
  }, [error, setSnackbar]);

  return { staffMember: data || EMPTY_STAFF_MEMBER, error, ...rest };
}
